export default {
    title: 'AELU',
    ssv: 'Specific skill visa',
    what_ssv: 'Specific skill visa',
    representative_message: 'Representative message',
    aeru_feature: 'Features of AELU',
    aeru_how_to_use: 'Flow of use',
    aeru_q_a: 'Q & A',
    aeru_function: 'Functions of AELU',
    aeru_fee: 'AELU charges',
    login: 'Login',
    db_top_comment1: 'First in the industry! Smartphone online training site for "Specific skill Visa Examination". ',
    db_top_comment2: 'AELU is a web service that supports the acquisition of specific skill visas by studying for exams, exam information, and application agency.',
    db_top_pr: 'Use your Specific Skill Visa to seize new opportunities.',
    member_regist: 'Member registration',
    registration_support_organization: 'What is a registration support organization?',
    rso_dec1: 'There are two organizations in the specific skill system, the specific skill affiliated organization and the registration support organization. A specific skill affiliation organization is a company (accepting organization) that employs foreigners with specific skills. The institution to which the specific skill belongs must provide support for foreigners with specific skills in the workplace, daily life, and society.',
    rso_dec2: 'Since there are specialized contents in supporting foreigners with specific skills, there are cases where it is difficult for the company that employs foreigners with specific skills, the " institution to which the specific skills belong ", to provide the support. A registration support organization is an organization that is entrusted to a specific skill affiliated organization to create and implement a support plan for foreigners with specific skills.',
    rso_dec3: 'A registration support organization is an organization that is entrusted to a specific skill affiliated organization to create and implement a support plan for foreigners with specific skills.',
    rso_dec4: 'The registration support organization will provide all support based on the No. 1 Specified Skilled Alien Support Plan through a support consignment contract with the host organization.',
    rso_dec5: '○ In order to become a registration support organization, you need to be registered by the Commissioner of the Immigration Bureau of Japan.',
    rso_dec6: '○ The registered institutions will be registered in the registration support organization register and will be posted on the Immigration Bureau of Japan website.',
    rso_dec7: '○ The registration period is 5 years and needs to be renewed.',
    rso_dec8: '○The registration support organizations are required to submit various notifications to the Immigration Bureau of Japan at any time. ',
    article1: 'What is a specific skill visa?',
    article1_dec1: 'With the enactment of the revised Immigration Control Act on December 8, 2018, the status of residence Specific Skills was newly established. Enforced in April 2019.',
    article1_dec2: 'A new status of residence Specific Skills will be established in two stages. (No. 1 and No. 2)',
    article1_dec3: 'The target industries are 14 industries.,',
    article1_dec4: 'The target foreigners requirement is a person who has skills that require considerable knowledge or experience. In other words, those who have completed three years of technical intern training or those who have passed the equivalent Japanese language and proficiency test are eligible.',
    article1_dec5: 'Specific Skill No. 1 is allowed to stay for up to 5 years as a person with certain skills. Family members are not allowed.',
    article1_dec6: 'As a person with skilled skills, Specific Skill No. 2 is given a status of residence equivalent to general employment by passing a specialized examination during the period of Specific Skill No. 1. \n (By renewing the period of stay, you can live permanently, and you can bring your family with you.),',
    article2: 'Representative message',
    article2_sub1: 'Dont abandon Japan yet',
    article2_dec1: 'We would like to express our sincere gratitude to the many technical intern trainees and returning trainees who came to Japan as technical intern trainees, acquired skills, and spared no effort for the development of their own country. I think that the appearance of practicing for the sake of the family and for the home country, which is not in Japan today, is the original human appearance. While I have been involved in the technical intern training business for a long time, there is no way to enter the country only with a technical intern trainee visa, and I take advantage of that opportunity, practice firmly in Japan, open a business in my own country, and my country is developing greatly I saw a lot. However, in April 2019, a visa Specific Skill Visa was constructed, which fulfills the desire to enjoy Japan, which cannot be fully learned in the prescribed number of years. I hope that many foreigners visiting Japan who have ambitions behind their eyes, which are rare in Japan, can develop Japan together. Above all, I would like to have people like Japan, increase the number of permanent residents, and create a society where they can live together.',
    article2_dec2: 'Visualization Co., Ltd.',
    article2_dec3: 'President and CEO',
    article2_dec4: 'Kazuhiko Horiuchi',
    article3: 'Three features provided by AELU',
    article3_sub1: 'Studying for online exams',
    article3_sub1_dec1: 'AELU, which allows you to prepare for the specific skill test on your smartphone, prepares pseudo-questions after 30 questions in all 14 industries, including past questions, and you can take measures as many times as you like toward the exam date. If you exceed the specified score for the questions that are popped out by AI, you will definitely pass the exam!',
    article3_sub2: 'Exam information',
    article3_sub2_dec1: 'Test information that is very difficult for foreign visitors to Japan to understand will be automatically added when the test information of the selected industry is updated after registration, and the user will be notified.',
    article3_sub3: 'Exam application agency',
    article3_sub3_dec1: 'As with the exam information, it is very difficult for foreign visitors to Japan to apply for the exam, and you cannot even take the exam without completing the online procedure. When you register, you can post the information, already have the application form, and apply at the same time as the test announcement.',
    article4: 'Function introduction after passing the test',
    article4_sub1: 'Congratulations on successful applicants \n Cash back (domestic or international)',
    article4_sub1_dec1: 'If you already live in Japan and pass using AELU and upload the pass number and pass certificate to your user screen, you can get cash back on the same day. Cash back plan Product: Online Gift Certificate (Amazon Gift Certificate Email) Type, Googleplay, iTunes gift card) 5000 yen worth cash back from LINE official account.',
    article4_sub2: 'Refer-a-friend campaign',
    article4_sub2_dec1: 'Invite applicants to Japan to Japan who are in Japan or abroad to join the FB group, the user will tell the management number of himself and cash back to the person associated with that number, and 1000 online gift certificates will be given to the introducer one month after joining. Yen cash back.',
    article4_sub3: 'After getting a visa, looking for a job is  \n  AI automatic matching (undecided)',
    article4_sub3_dec1: 'After passing the certification exam using AELU, upload the pass number and pass certificate on the user screen, and you will receive automatic offers from all companies in Japan. Interviews will also be conducted online, and you will be able to enter the country, move, and get a job with peace of mind by connecting online even in the preliminary informal chapter!',
    article4_sub4: 'Regular check of residence card \n Cash back (undecided),',
    article4_sub4_dec1: 'If you check your residence card once a month without aer in the residence card check application One Check Tab, you will get 10,000 yen cash back in one year.,',
    article5: 'Specific function introduction,',
    article5_sub1: 'You can look back on the problem you solved',
    article5_sub1_dec1: 'You can accumulate the exam contents that you have trained online and use your own tools to understand the habits of users and overcome problems that you are not good at. Since you can prepare for the test as many times as you like, record all the score history and test time, and make it as close as possible to the actual test day. In addition, you can understand the question better because it is written in both your own language and Japanese.',
    article5_sub2: 'Permanently save your resume at the time of entry',
    article5_sub2_dec1: 'When you take the specific skill visa test and apply for a visa, you will need a resume when you enter Japan as a technical intern trainee. Originally stored by a management organization (cooperative) or sending organization, you can store it by yourself after obtaining a specific skill visa.',
    article5_sub3: 'Registration function of your country and field,',
    article5_sub3_dec1: 'Since the language of your own country and Japan are used together, you can understand the questions well and take countermeasures. In the original exam, only Japanese is available, so you can take measures only in Japanese.,',
    article5_sub4: 'Reminders of certification exam requirements and information',
    article5_sub4_dec1: 'When the test schedule for the desired occupation is uploaded to the HP by each test group, it will be automatically reminded, the user will be notified, the test date will be set on the user screen, and the timer will operate automatically.',
    article5_sub5: 'Learning using screening',
    article5_sub5_dec1: 'You can extract the weak points of the user and prepare for the exam.',
    article5_sub6: 'Online learning consultations and interviews using smartphone cameras.',
    article5_sub6_dec1: 'While proceeding with the exam preparation using Aer, you will be able to clarify the meaning and intention of the question in the form of online calls and chats. It may not be necessary for those who are accustomed to Japan or who are familiar with it, but the basic call consultation service is the most reassuring way to check any concerns before the exam!',
    article6: 'Fee',
    article6_sub1: 'AELU usage fee',
    article6_sub1_dec1: 'You can study for the specific skill visa test without any restrictions. You can consult online in your native language. * You can also use it as an interpreter during normal times. \n Announcement to the test site is possible on the day of the test. \n Resume upon entry can be saved forever. \n After passing the exam, simply register your specific skill visa pass number to introduce your desired job. (Undecided).',
    article6_sub2: 'Exam application agency',
    article6_sub2_dec1: 'You cannot apply during work, and you will not be able to take the certification exam unless you apply, so we will apply immediately when the certification exam information is available so that you will not miss the exam date.',
    article7: 'Cashback campaign in progress!',
    article7_dec1: 'From those who passed the exam, those who registered the visa number for this service will receive a cashback of 5,000 \n yen! Click here for how to participate in the campaign.',
    article8: 'Now lets register with AELU!',
    dashboard: 'Dashboard',
    member_info: 'Registration of profile information',
    first_name: 'Name',
    midle_name: 'middle name',
    family_name: 'Surname',
    half_width_Roman: 'Romaji half-width',
    password: 'password',
    password_confirm: 'Password confirmation',
    mail_adress: 'mail address',
    lineId: 'LINE ID',
    country_id: 'Country code',
    phone: 'phone number',
    issuing_country: 'Select country / region of ID card issuance',
    IDtype: 'ID type selection',
    residence_card: 'Residence card or ID card',
    passport: 'passport',
    regist: 'Registration',
    is_required: 'Is mandatory',
    sign_up: 'sign up',
    residence_front: 'Surface upload',
    residence_back: 'Upload on the back',
    passport_upload: 'Upload your passport',
    error_file: 'Please upload the image',
    post_resume: 'Submit resume',
    resume_upload: 'Upload resume',
    click_upload: 'Click to upload',
    image_drop: 'Or drag and drop the image file',
    select_language: 'Choice of mother tongue',
    vietnamese: 'Vietnamese',
    chinese: 'Chinese',
    english: 'English',
    khmer: 'Khmer',
    indonesian: 'Indonesian',
    tagalog: 'Tagalog',
    burmese: 'Burmese',
    hindu: 'Hindu',
    lao: 'Lao',
    mongolian: 'Mongolian',
    bengali: 'Bengali',
    sinhala: 'Sinhala',
    banglodesh: 'Bangladeshi',
    malay: 'Malay',
    nepali: 'Nepali',
    thai: 'Thai',
    japanese: 'Japanese',
    error_lang: 'Please select your native language.',
    select_ouccupation: 'Job type selection',
    select_max_three: 'You can select up to three.',
    industry_id_1: 'Long-term care industry',
    industry_id_2: 'Building cleaning business',
    industry_id_3: 'Raw material industry',
    industry_id_4: 'Industrial machinery manufacturing industry',
    industry_id_5: 'Electrical and electronic information related industries',
    industry_id_6: 'Construction industry',
    industry_id_7: 'Shipbuilding / marine industry',
    industry_id_8: 'Car maintenance industry',
    industry_id_9: 'Aviation industry',
    industry_id_10: 'Accommodation business',
    industry_id_11: 'Agriculture',
    industry_id_12: 'Fishery',
    industry_id_13: 'Food and beverage manufacturing',
    industry_id_14: 'Restaurant business',
    industry_id_15: "Raw Material, Industrial Machinery, and Electrical/Electronic Information-related Manufacturing Industry",
    industry: 'Industry',
    error_occupation: 'Please select one or more job types.',
    do: 'To do',
    news_tpic: 'news',
    days_until_exam: 'Remaining days until the exam',
    estimated_pass_rate: 'Estimated pass rate',
    average_score_taken: 'Average score of the test taken',
    exam: 'The exam is',
    let_aim: 'Lets aim for',
    score: 'point',
    solve_problem: 'Solve the question',
    recommend_problem: 'AELUs recommended question',
    solved_problem: 'Question solved in the past',
    looking_solved: 'Check past questions',
    application_agency: 'Exam application agency service',
    billing: 'Billing',
    more_look: 'Check more',
    more_look2: 'Check more',
    facebook: 'Facebook',
    google: 'Google',
    until_not_account: "If you don't have an account yet",
    or: 'or',
    other_way: 'In other ways',
    not_have_account: 'If you do not have an account',
    have_account: 'If you have an account',
    forgot_password: 'If you have forgotten your password',
    this: 'Here',
    at_login: 'Login with',
    pass_condition: '8 or more single-byte alphanumeric capital letters',
    at_sign_up: 'New registration with',
    agreement1: 'By agreeing to the following and choosing to continue , AELU',
    terms: 'Terms of Service',
    agreement2: 'I agree with you.',
    agree: 'Agree and continue',
    account_confirm: 'Confirmation code',
    confirm: 'Confirmation',
    not_confirm: 'The confirmation code is unconfirmed.',
    move_confiirm: 'Moves to the confirmation code input screen',
    top: 'Top',
    news_list: 'news list',
    problim_list: 'Question list',
    learning_consul: 'Learning consultation',
    agency: 'Exam information',
    of_trend: 'About the trend of the test',
    start_test: 'Start the test',
    study_mode: 'Learning mode',
    order_question: 'Question',
    of_question: 'In question',
    question_current: 'Question correct answer',
    to_mypage: 'to My page',
    correct_answer: 'Correct answer!',
    correct_answer_normal: 'Correct answer',
    no_correct_answer: 'Incorrect answer',
    next: 'To the next question',
    finish_all: 'Answered all the questions!',
    your_score: 'Your score is',
    is: 'is!',
    result_description: 'You can solve other questions from View  questions  list. You can also look back on the questions you have solved in the past from the questions list page.',
    back_quiz_list: 'Check questions list',
    retry: 'Solve this questions again',
    no_description: 'There is no explanation',
    show_ans: 'Check the answer',
    of_solved_problem: 'Question solved in the past',
    of_solved_problem_list: 'List of questions solved in the past',
    solved_description: 'You can check again the learning test for the specific skill visa test of the long-term care industry.',
    before_result: 'Previous results',
    looking_back: 'check again ',
    back_solved_problem_list: 'Check a list of questions solved in the past',
    again_retry: 'Looking back on this question again',
    done_member_regist: 'Thank you for registering as a member!',
    done_member_regist_description: 'Each service will be available after you pay the service usage fee. \nPlease register your payment information.',
    choose_payment: 'Choose a payment method',
    service_content: 'Service contents',
    test_info_service: 'Exam information service',
    usage_fee: 'usage fee',
    test_fee: '500 yen + tax',
    application_fee: '20000 yen + tax',
    method_payment: ' payment method',
    LINE_pay: 'LINE Pay',
    line_pay_description: '* Please save the QR code image and make a payment within the LINE Pay service. When paying with LINE Pay it will take time for the management to confirm.',
    save_qr: 'Save QR code',
    next_stage: 'next',
    credit_card: 'credit card',
    copmplete_payment: 'Payment is complete.',
    copmplete_payment_descript: 'Now that the payment has been completed, you can use the online exam study function, exam information, and exam application agency service.',
    start_sevice: 'Start using the service',
    to_payment: 'To payment screen',
    of_news_list: 'news list',
    done_payment: 'Payment has been completed. ',
    tv_consult: 'Videophone consultation',
    tell_consult: 'Telephone consultation',
    learning_consul_descript01: 'Exam application',
    learning_consul_descript02: 'We will act on your behalf',
    money_unit: 'JPY',
    learning_consul_unit: 'Once',
    fault_payment1: 'Payment failed.',
    fault_payment2: 'Please try again.',
    no_examination: 'Not yet',
    no_exam: 'No exam yet',
    undecided: 'Undecided',
    retry_login: 'Please log in again',
    no_problem: 'There is no qestion solved',
    do_problem: 'Solve the question',
    qa_title: 'Frequently Asked Questions',
    search_category: 'Narrow down by category',
    search_freeward: 'Search by free word',
    test_result: 'Practice test results',
    to_top: 'To the top',
    missPassword: 'Wrong password or email address',
    sample_problem: 'Experience studying for an online exam',
    exercises: 'Exercises',
    let_exercises: "Let's solve only one real problem!",
    to_qa: 'Check more Q & A',
    read_more: 'Check more',
    account_setting: 'Account Setting',
    profile_setting: 'Profile settings',
    notification_setting: 'Notification settings',
    logout: 'Logout',
    changeEmail: 'Change email address',
    changePassword: 'Change password',
    change: 'change',
    save: 'save',
    change_success: 'Change completed',
    now_password: 'Current password',
    new_password: 'new password',
    check_new_password: 'New password (confirmation)',
    do_logout: 'logged out',
    done_learning_consul_payment: 'Payment has already been completed.',
    past_exam: 'Past questions',
    update_info: 'Updating the latest information',
    official_sns: 'Official SNS',
    privacy_policy: 'privacy policy',
    terms_service: 'Terms of service',
    transaction_law: 'Notation based on the Specified Commercial Transactions Law',
    selectCountry: 'Please select a country',
    goInquiry: 'Proceed to inquiry',
    lineInquiry: 'Contact us via LINE',
    regist_accept_certificate: 'Registration of specific skill visa acquisition pass certificate',
    accept_certificate_description: 'You can register your pass certificate and number',
    accept_certificate: 'Certificate of acceptance',
    accept_number: 'Pass number',
    immigration_resume: 'Resume registration at the time of entry',
    resendCode: 'Resend verification code',
    line_at_register: 'Service inquiries via LINE @',
    study: 'Study and check again',
    study_text: 'Download learning text',
    do_resume_update: 'Please upload your resume',
    done_resume_update: 'Thank you for registering your resume!',
    regist_resume_enter: 'Registration of resume at the time of entry',
    about_company: 'About the operating company',
    add_exam_info_detail: 'Exam information has been added. Click here for details and application',
    regist_result_get_money: 'Register your exam results and get your money',
    detail: 'Details',
    about_withdrawal_subsc: 'About withdrawal and cancellation of subscription',
    apply_withdrawal: 'Application for unsubscription',
    apply_subsc: 'Application for unsubscribe from subscription',
    about_withdrawal: 'Withdrawal application',
    about_subsc: 'Unsubscribe from subscription',
    exam_info: 'Exam information',
    date: 'Date and time',
    day: 'Day',
    place: 'place',
    result_publication: 'result publication',
    result_publication_place: 'Place to announce the result',
    result_this_page: 'Will be announced on this page',
    exam_way: 'Exam format',
    exam_way2: 'Exam question format',
    include_exam_fee: 'Including test fee',
    exam_application_desc: 'Submission of exam application form. \n　Interaction with the exam office \n　Contacting what to prepare by the day (LINE @) \n  Consultation for any questions regarding the exam',
    self_application: 'Apply by yourself',
    application_method: 'How to apply',
    under_this_url: 'Please complete the application procedure from the following URL.',
    do_appliction: 'Apply for the exam',
    study_with_aeru: 'Use the exam study function from the top page to increase the pass rate.',
    line_at_consul: 'LINE @ learning consultation service',
    instagram: 'Instagram',
    do_signup: 'You have been authenticated. \n Please log in again.',
    gender: 'Gender',
    man: 'Male',
    woman: 'Female',
    input_problem_title: 'Contains the title of the problem ...',
    still_no_problem: 'No problem',
    enter_in_problem_trend: 'Contains a brief explanation of the exam such as the trends of the exam so far and the answer format (selection type).',
    correct: 'Correct answer',
    explanation: 'Explanation',
    problem: 'question',
    do_nursing_not_published: 'Exams are being conducted in the long-term care industry but past questions have not been published.',
    practical_exam_of_year: 'Year practical test',
    judgment_test_of_year: '2019 Judgment Exam',
    judgment_test_answer_of_year: '2019 Judgment Exam Answer',
    not_yet_test_material: 'Not yet exams in the raw material industry',
    not_yet_test_machinery: 'Not yet exams in the industrial machinery manufacturing sector',
    not_yet_test_electronic: 'Not yet exams in the electrical and electronic information related industry',
    not_yet_test_construction: 'Not yet exams in the construction industry',
    not_yet_test_shipbuilding: 'Not yet exams in the shipbuilding and marine industry',
    do_automobile_not_published: 'Exams are being conducted in the field of automobile maintenance but past questions have not been published.',
    do_aviation_not_published: 'Exams are being conducted in the aviation industry but past questions have not been published.',
    do_agricultural_not_published: 'Exams are being conducted in the agricultural sector but past questions have not been published.',
    do_fishery_not_published: 'Exams are being conducted in the fishery field but past questions have not been published.',
    do_food_not_published: 'Exams are being conducted in the food and beverage manufacturing industry but past questions have not been published.',
    do_restaurant_not_published: 'Exams are being conducted in the food service industry but past questions have not been published.',
    schedule_undecided: '(* Schedule is undecided)',
    year: 'Year',
    month: 'Moon',
    texts_learning: 'Textbooks for learning each industry',
    texts_learning_test: 'Specific skill evaluation exam learning text (Japanese)',
    skill_test_sample: 'Skill evaluation exam sample',
    japanese_test_sample: 'Japanese Evaluation exam Sample',
    not_building_texts: 'There is no learning textbook for the building cleaning industry yet.',
    not_material_texts: 'There is no learning textbook for the raw material industry yet.',
    not_machinery_texts: 'There is no learning textbook in the field of industrial machinery manufacturing yet.',
    not_electronic_texts: 'There is no learning textbook for electrical and electronic information related industries yet.',
    not_shipbuilding_texts: 'There is no learning textbook for the shipbuilding / marine industry yet.',
    not_automobile_texts: 'There is no learning textbook for the automobile maintenance industry yet.',
    not_accommodation_texts: 'There is no learning textbook for the accommodation industry yet.',
    not_food_texts: 'There is no learning textbook for the food and beverage manufacturing industry yet.',
    not_restaurant_texts: 'Food service skill measurement exam learning textbook',
    each_depertment_texts: 'Textbooks for exam learning in each department',
    skill_test_basic: 'Skill evaluation exam learning text (basic technology)',
    skill_test_safety: 'Skill evaluation exam learning text (work safety / quality)',
    skill_test_aircraft: 'Skill evaluation exam learning text (aircraft overview)',
    texts_livestock: '[Textbook for learning livestock farming] Japanese version',
    texts_cultivated: '[Text for learning farming agriculture] Japanese version',
    skill_test_fishery: 'Fishery skill measurement exam (fishery)',
    skill_test_general_fishery: 'Fishery skill measurement  exam (general fishery)',
    skill_test_safety_fishery: 'Fishery skill measurement exam(fishery safety)',
    skill_test_specialty_fishery: 'Fishery skill measurement exam (fishery specialized net related)',
    skill_test_related_fishery: 'Fishery skill measurement exam (fishery specialty fishing related)',
    skill_test_aquaculture: 'Fishery skill measurement exam (aquaculture)',
    skill_test_general_aquaculture: 'Fishery Skills Measurement exam (Aquaculture General / Safety)',
    skill_test_feeding_aquaculture: 'Fishery skill measurement exam (feeding and aquaculture)',
    skill_test_non_feeding_aquaculture: 'Fishery skill measurement exam (related to unfed aquaculture)',
    registration_skill_visa: 'Registration of certificate of acceptance of specific skill visa',
    please_register_pdf_number: 'Please register the photo or PDF of the pass certificate for obtaining a specific skill visa and the pass number on the pass certificate.',
    regist_and_get_cash_bag: 'If you register now, you can get 5000 yen with a cash bag.',
    thank_you_regist_visa_pass: 'Thank you for registering the certificate of passing the specific skill visa!',
    exam_info_detail: 'Outline of exam implementation',
    em_exam_detail_language: 'Scheduled to be done in the local language',
    em_exam_detail_method: 'Department exam, practical exam',
    em_exam_detail_way: 'Computer-based testing (CBT) paper test method or work test method such as production',
    em_exam_detail_section: '19 examination categories (casting, forging, die casting, machining, metal stamping, ironwork, factory sheet metal, plating, aluminum anodization, finishing, mechanical inspection, machine maintenance, electronic equipment assembly, electrical equipment assembly, printed wiring board manufacturing, Plastic molding, painting, welding, industrial packaging)',
    em_exam_detail_notify: 'After the exam, send a result notification by email.',
    em_exam_detail_border: 'Department test: 65% or more \n Practical test: 60 points or more',
    ss_exam_detail_language: 'Japanese',
    ss_exam_detail_method: 'The proficiency test is conducted by a practical test and a department test. \n Practical exams are conducted for each business category. \n The department test is conducted for each business category by the paper test method.',
    ss_exam_detail_way: 'Paper test method, etc.',
    ss_exam_detail_section: 'Department / Practice / Skills: Welding, painting, ironwork, finishing, machining, electrical equipment assembly',
    ss_exam_detail_notify: '-',
    ss_exam_detail_border: 'Department test: 60% or more \n Practical test: Judgment based on practical results',
    c_exam_detail_language: 'Japanese',
    c_exam_detail_method: 'The proficiency test is conducted by a practical test and a department test.',
    c_exam_detail_way: 'Computer-based testing (CBT), practical test is a method specified by a registered corporation',
    c_exam_detail_section: '-',
    c_exam_detail_notify: 'Published on the website',
    c_exam_detail_border: 'Department test: 65% or more \n Practical test: Judgment based on practical results',
    cm_exam_detail_language: 'Japanese',
    cm_exam_detail_method: 'The proficiency test is conducted by a practical test and a department test.',
    cm_exam_detail_way: 'Perform academic and practical exams by computer-based testing (CBT)',
    cm_exam_detail_section: 'Subject of subject examination \n Elementary knowledge about structure, function and handling method \n Elementary knowledge about inspection, repair and adjustment \n Elementary knowledge about structure, function and handling method of testing machine, measuring instrument and tool for maintenance \n Elementary knowledge about the properties and usage of materials and fuels and fats \nPractical exam subjects \nA Simple basic work \nB Disassembly, assembly, simple inspection and adjustment \nC Easy repair \nD Easy Handling of maintenance testing machines, measuring instruments and tools.',
    cm_exam_detail_notify: '',
    cm_exam_detail_border: 'Department test: 65% or more Practical test: Total score 60% or more',
    a_exam_detail_language: 'Local language and Japanese',
    a_exam_detail_way: 'Computer-based testing (CBT), paper test method',
    a_exam_detail_section: 'Department cultivated agriculture in general, safety and health, varieties / characteristics of cultivated crops, cultivation environment (facility / equipment / materials / machinery), cultivation method / management, pest / weed control, harvesting / adjustment / storage / shipping ②Practical soil observation , Handling of fertilizers / pesticides, handling of seeds, environmental management, handling of materials / equipment / machines, work related to cultivation, safety and health ③ Listening to the contents of agricultural work instructed in Japanese',
    a_exam_detail_notify: 'Published on the website',
    a_exam_detail_border: 'The total score exceeds the judgment reference point set by the National Chamber of Agriculture.',
    avi_exam_detail_method: 'The proficiency exam is conducted by a practical exam and a department exam.',
    avi_exam_detail_section: 'The questions will be given from the texts posted on the website of the Japan Aviation Technology Association. Practical skill conclusion, electrical measurement',
    avi_exam_detail_notify: '',
    avi_exam_detail_border: 'Department test: 65% or more Practical test: Total score 65% or more',
    f_exam_detail_language: 'Japanese',
    f_exam_detail_method: 'The proficiency test is conducted by a practical test and a department test.',
    f_exam_detail_way: 'Perform academic and practical exams by computer-based testing (CBT)',
    f_exam_detail_section: 'The test subject shall confirm that a certain degree of work in the fishery field (fishery) or fishery field (aquaculture) can be carried out accurately by understanding the instructions of the supervisor or can be carried out at its own discretion, and is merely specialized. It is not an evaluation of the presence or absence of knowledge, but it is also possible to evaluate the presence or absence of correct judgment and work knowledge necessary for carrying out work in the fishery field (fishery) or fishery field (aquaculture).',
    f_exam_detail_notify: 'Published on the website',
    f_exam_detail_border: 'Those whose total score of the written test and the practical test exceeds the judgment standard score set by the proficiency test executing agency are accepted.',
    no_exam_info: 'No test summary information has been released yet',
    language: 'Implementation language',
    method: 'Implementation method',
    way: 'Implementation method',
    section: 'Exzmination category',
    notify: 'Notification of examination results',
    border: 'Examination result criteria',
    go_line_at: 'To line @',
    thank_you_and_deactivate: 'Thank you for using.For the procedure for withdrawing from the service, please enter the procedure for withdrawal from the line @ window below. To cancel the regular payment, please enter the cancellation of the regular payment from the line @ window below. We will carry out the procedure as soon as we get confirmation.',
    thank_you_and_subscribe: 'Thank you for using. To cancel the regular payment, please enter the cancellation of the regular payment from the line @ window below. \n We will cancel the contract as soon as we receive confirmation.',
    ten_thousand_yen: 'Ten thousand yen',
    yen_per_month: 'JPY / month',
    how_to_use_this_service: 'Flow of use',
    selecting_a_browser: 'Browser selection',
    selecting_a_browser_dec: 'Access https://aelu.co.jp with a browser (Google chrome, Safari, edge, etc.)* There is no app.',
    provisional_registration: 'Temporary registration',
    provisional_registration_dec: 'Log in with your Facebook or Google ID or register with your email address. After selecting the desired language and desired occupation, you can browse the online certification exam mock content.',
    full_registration: 'Main registration',
    full_registration_dec: 'Click "Main Registration" on the online certification exam content page, fill in the required information, and use all services including the 14 industry certification exam practice questions.',
    name_validate_message: 'Please enter the information with the same spelling as it appears on your passport.',
    live_at_area: 'Area where you currently live',
    agency_application: 'Acting for exam application',
    mypage: 'My page',
    myanmar: 'Burmese',
    exam_list: 'Examination schedule list',
    no: 'No.',
    times: 'Times',
    application_start: 'Start application',
    application_end: 'Application deadline',
    enforcement: 'Implementation',
    applicated: 'Applied',
    reception_time: 'Reception time',
    announthment_d: 'Date of announcement of acceptance',
    reception_period: 'Application period',
    detail_link: 'check the details',
    exam_country: 'Host country',
    line: 'LINE',
    vietnum: 'Vietnam',
    laos: 'Laos',
    malaysia: 'Malaysia',
    bangladesh: 'Bangladesh',
    indo: 'India',
    nepal: 'Nepal',
    mongol: 'Mongolia',
    indonesia: 'Indonesia',
    th: 'Thailand',
    philipine: 'Philippines',
    my: 'Myanmar',
    uzbekistan: 'Uzbekistan',
    pakistan: 'Pakistan',
    japan: 'Japan',
    news_title: 'News about specific skill visas',
    missNowPassword: 'The current password is incorrect',
    article6_sub2_dec2: 'If you apply here, we will also announce the exam application, the exm price, and the venue until the day of the exam.',
    create_naw_password: 'change Password',
    send_confirmcode: 'A verification code has been sent',
    edit: 'change',
    success_new_password_setting: 'You have set a new password.',
    error_email: 'This is an unregistered email address.',

    click_here_businesses: "&quotClick here for businesses&quot",
    regist_organization_staff_info: "Registration of business / user information",
    organization_info: "Business Information",
    staff_info: "User-Information",
    org_name: "Business name",
    url: "URL",
    org_scale: "scale",
    org_zip: "Postal code",
    org_adress1: "Prefectures",
    org_adress2: "City",
    org_adress3: "Address / Apartment name",
    org_industry: "Industry",
    org_category: "Category",
    org_description: "Description",
    org_established_at: "Establishment year",
    org_phone: "Business phone number",
    failed_established_at: "Invalid date. ",
    staff_name: "username",
    form_miss: "There is a mistake in the input form. ",

    back_joboffer_detail: "Return to job details <",
    create_joboffer: "Create a job",
    edit_joboffer: "Edit Jobs",
    stop_posting: "Stop posting",
    delete: "&quotdelete&quot",
    job_title: "Job Title",
    job_catch_phrase: "Job Catch Copy",
    job_category: "Occupation category",
    employed_company_name: "Employed company name",
    work_location: "Work location",
    employment_status: "Employment status",
    full_time_employee: "Regular employee",
    part_time_job: "part-time job",
    temporary_staff: "Dispatched labor",
    contract_employee: "Contract employee",
    intern: "Intern",
    subcontracting: "Subcontracting",
    contract: "Contract",
    new_graduate: "New graduate",
    salary: "Salary",
    annual_income: "annual income",
    monthly_salary: "Monthly salary",
    weekly_salary: "Weekly salary",
    dayly_salary: "Daily salary",
    job_offer_attension1: "It is necessary to specify the prescribed working conditions etc. according to the law for the work content",
    job_offer_attension2: "Please check the working conditions, etc. that are required to be clearly stated by law, and then describe the work content. (Reference: Ministry of Health, Labor and Welfare, Prefectural Labor Bureau &quotTo all companies recruiting workers&quot)",
    job_offer_attension3: "You may not be able to post a job if you use language that limits the target persons age, gender, or social status. ",
    job_offer_attension4: "Frequently unpublished examples: &quotWelcome in their 20s&quot &quotWelcome to young people&quot &quotWomen welcome / limited&quot &quotStudents only&quot",
    work_content_appeal: "Job content and appeal points",
    work_content_appeal_desc: "It will be easier for job seekers to be interested if you tell them the appeal points first. ",
    human_resources_seek: "Human resources to seek",
    human_resources_seek_desc: "Not only the skills you are looking for, but also information that allows job seekers to imagine the workplace. ",
    working_hours: "Working hours",
    traffic_access: "Traffic access",
    traffic_access_desc: "Not only public transportation information, but also commute by car, whether there is a parking lot for employees, etc. ",
    required: "Required",
    optional: "Any",
    other: "Other",
    photo: "Photo",
    upload_video: "Upload video",
    job_tag: "Job Tag",
    until_select_three: "Up to 3 selectable",
    senior_support: "Senior support",
    salary_increase_promotion: "Pay increase / promotion available",
    no_overtime: "No overtime",
    target_hiring_time: "Recruitment target time",
    additional_questions: "Additional questions",
    job_offer_title: "Job name",
    public: "Release",
    private: "private",
    public_status: "Public status",
    occupation: "Occupation",
    walfare: "Treatment / Benefits",
    create: "&quotcreate&quot",
    hour: "Time",
    back_mypage: "Return to My Page <",
    job_offers: "Job listing",
    look_matches: "See the match list",
    now_public: "Now open",
    now_private: "Unpublished",
    check: "Confirm",
    edit2: "To edit",
    news_detail: "News details",
    prefectures: "Prefectures",

    hokkaido: "Hokkaido",
    aomori: "Aomori",
    iwate: "Iwate",
    miyagi: "Miyagi",
    akita: "Akita",
    yamagata: "Yamagata",
    fukushima: "Fukushima",
    ibaraki: "Ibaraki",
    tochigi: "Tochigi",
    gunma: "Gunma",
    saitama: "Saitama",
    chiba: "Chiba",
    tokyo: "Tokyo",
    kanagawa: "Kanagawa",
    niigata: "Niigata",
    toyama: "&quotToyama&quot",
    ishikawa: "Ishikawa",
    fukui: "Fukui",
    yamanashi: "Yamanashi",
    nagano: "Nagano",
    gifu: "Gifu",
    shizuoka: "Shizuoka",
    aichi: "Aichi",
    mie: "Triple",
    shiga: "Shiga",
    kyoto: "Kyoto",
    osaka: "Osaka",
    hyogo: "Hyogo",
    nara: "Nara",
    wakayama: "Wakayama",
    tottori: "Tottori",
    shimane: "Shimane",
    okayama: "Okayama",
    hiroshima: "Hiroshima",
    yamaguti: "Yamaguchi",
    tokushima: "Tokushima",
    kagawa: "Kagawa",
    echime: "Ehime",
    kochi: "Kochi",
    fukuoka: "Fukuoka",
    saga: "Saga",
    nagasaki: "&quotNagasaki&quot",
    kumamoto: "Kumamoto",
    oita: "Oita",
    miyazaki: "Miyazaki",
    kagoshima: "Kagoshima",
    okinawa: "Okinawa",
    sinhalese: "Sinhala",
    exam_region: "Prefectures",
    exam_place_list: "List of venues",
    exam_place_name: "Examination venue name",
    care_evaluation_test: "Long-term care skill training evaluation test",
    clean_building_test: "Building cleaning industry past problems",
    answer: "answer",
    skill_test_measurement: "Skill measurement test",
    exam_problem: "question of exam",
    fields: "Fields and vegetables",
    gardening: "Facility gardening",
    mushroom: "mushroom",
    fruit: "Fruit tree",
    dairy: "dairy",
    poultry: "Poultry",
    pig: "Pig farming",
    beginner: "Beginner",
    professional: "Professional grade",
    advanced: "Advanced",
    technical_training_test: "Technical intern training evaluation test",
    exam_part: "Part of the exam questions",
    tokoha_fruit: "Tokoha Fruit Tree",
    deciduous_fruit: "Deciduous fruit tree",
    ver: "Edition",
    errata: "errata",
    form_work: "Formwork construction",
    construction: "Plastering",
    tunnel_line: "Tunnel propulsion line",
    earth_work: "Earthwork",
    loofing: "Roofing",
    elecommunication: "telecommunication",
    reinforcing_contstruction: "Reinforcing bar construction",
    reinforcing_joint: "Reinforcing bar joint",
    wall_painting: "Painting (wall covering)",
    board_finish: "Board finish, interior finish",
    steeplejack: "Tobi",
    spray_insulation: "Sprayed urethane insulation",
    marine_civil: "Marine Civil Engineering",
    concrete_pumping: "Concrete pumping",
    construction_machinery: "Construction Machinery Construction",
    learning_text: "Learning text",

    basic_aircraft: "Conclusion of basic aircraft technology, electrical measurement",
    worksafety_quality: "Work safety, quality",
    aircraft_overview: "Aircraft overview",
    fish_general: "Fishery in general",
    fish_safety: "Fishery safety",
    network_relations: "Fishery Specialized Classes",
    fish_relations: "Fishery specialty fishing related",
    aquaculture_general: "Aquaculture in general",
    feeding_aquaculture: "Aquaculture specialty feeding and aquaculture related",
    unfed_aquaculture: "Aquaculture specialty unfed aquaculture-related",
    attachment: "Attachments",
    glossary: "Glossary",
    feneral_customer: "General customer service",
    food_dring_cooking: "Cooking food and drink",
    hygiene_management: "hygiene management",
    visa_application: "Application for specific skill visa",
    certificate_residence_tax: "1. Certificate of residence tax (for the last year)",
    salary_income_withholding : "2. Copy of salary income withholding slip",
    national_health_insured: "3. A copy of the National Health Insurance insured persons card (if the person is enrolled)",
    national_health_payment: "4. National Health Insurance Premium Payment Certificate",
    national_health_receipt: "5. Copy of National Health Insurance Premium Receipt",

    technical_intern_training2: "6. Documents certifying that technical intern training No. 2 has been successfully completed",
    need_the_following : "You need one of the following: ",
    pass_certificate_test_specialized : "・ A copy of the pass certificate of the practical skill test of the skill evaluation test (specialized grade)",
    technical_intern_training3: "・ A copy of the pass certificate of the practical test of the skill test (3rd grade)",
    evaluation_record_technical_intern: "・ If you do not pass the above exam, you need to fill in the evaluation record for the technical intern trainee. ",
    cartificate_pass_basic_test: "As an alternative to 7.6, you can submit a copy of the pass certificate of the Japan Foundation Japanese Basic Test or a copy of the pass certificate of the Japanese Language Proficiency Test (N4) or higher. ",
    change_permission_application: "8. Photograph of change permission application (vertical 4 cm x horizontal 3 cm)",
    resume_data_time_entry: "9. Resume data at the time of entry",
    select_file: "Select files",


    
    description_movie: "Explanation video",
    how_to_use_movie: "How to use video",
    movie_news: "1. News about specific skill visas",
    movie_exam: "2. Number of days remaining until the test date",
    movie_predict_pass: "3. Estimated pass rate",
    movie_ave_study_test: "4. Average score of your own test you studied",
    movie_similar_exam: "5. Similar exam questions",
    movie_learning_text: "6. Download the learning textbook (textbook)",
    movie_solved_exam: "7. Problems I solved in the past",
    movie_pased_exam: "8. About seeing past problems that actually appeared",
    movie_resume_regist: "9. Resume registration at the time of entry",
    movie_pass_document_regist: "10. Registration of proficiency test pass",
    movie_agency_service: "11. Exam application agency service",
    movie_consule_service: "12. Learning consultation service",
    description_movie_trans: "If you want to watch in a language other than Japanese, click the gear mark, click subtitles and automatic translation, select your native language, and then watch.",
    "cultivated_agriculture_general": "Cultivated agriculture in general",
    "livestock_agriculture": "Livestock agriculture",
    "介護": "nursing",
    "ビルクリーニング": "Building cleaning",
    "建設": "construction",
    "自動車整備": "Car maintenance",
    "航空業": "Aviation industry",
    "農業": "Agriculture",
    "漁業": "Fishing",
    "飲食料品製造業": "Food and beverage manufacturing industry",
    "外食業": "Restaurant business",
    "型枠施工": "Formwork construction",
    "左官": "Plasterer",
    "コンクリート圧送": "Concrete pumping",
    "トンネル推進工": "Tunnel propulsion work",
    "建設機械施工": "Construction machinery construction",
    "大工": "carpenter",
    "屋根ふき": "Roofing",
    "電気通信": "telecommunication",
    "鉄筋施工": "Reinforcing bar construction",
    "鉄筋継手": "Reinforcing bar joint",
    "壁装（壁張り）": "Wall covering (wall covering)",
    "ボード仕上げ、内装仕上げ": "Board finish, interior finish",
    "とび": "Jump",
    "吹き付けウレタン断熱": "Sprayed firing insulation",
    "海洋土木工": "Marine civil engineering",
    "航空機の基本技術 締結、電気計測": "Aircraft basic technology conclusion, electrical measurement",
    "作業安全、品質": "Work safety, quality",
    "航空機概要": "Aircraft overview",
    "耕種農業全般": "Cultivated agriculture in general",
    "畜産農業": "Livestock agriculture",
    "漁業一般": "Fishing in general",
    "漁業安全": "Fisheries safety",
    "漁業専門 綱関係": "Fisheries specialty rope relations",
    "漁業専門 釣り関係": "Specialized in fishing related to fishing",
    "養殖業一般": "Aquaculture in general",
    "養殖業専門 給餌養殖関係": "Aquaculture specialty Feeding aquaculture",
    "養殖業専門 無給餌養殖関係": "Aquaculture specialty Unfed aquaculture",
    "接客全般": "General customer service",
    "飲食物調理": "Food and drink cooking",
    "衛生管理": "hygiene management",
    "日本語版": "Japanese version",
    "英語版": "English edition",
    "クメール語版": "Khmer version",
    "インドネシア語版": "Indonesian version",
    "インドネシア語・正誤表": "Indonesian errata",
    "ネパール語版": "Nepali version",
    "モンゴル語版": "Mongolian version",
    "ビルマ語版": "Burmese version",
    "ベトナム語版": "Vietnamese version",
    "タイ語版": "Thai version",
    "テキスト１": "Text 1",
    "テキスト２": "Text 2",
    "テキスト３": "Text 3",
    "テキスト４": "Text 4",
    "テキスト５": "Text 5",
    "ミャンマー(ビルマ)語版": "Myanmar (Burmese) language version",
    "カンボジア(クメール)語版": "Cambodia (Khmer) language version",
    "ミャンマー語版": "Burmese version",
    "中国語版": "Chinese version",
    "付属資料": "Attachment",
    "用語集": "Glossary",

invitation_code: "Invitation code",
exam_calender: "Exam schedule calendar",
move_exam_detail: "Would you like to go to the exam schedule details page?",
move: "Moving",
plece_select_language: "Please select a language",
select: "select",
midle_category: "Occupation",
select_industry_description: "At the start, AELU can only select up to 3 industries, so select only the industry you want to work for. If you&#39;re happy with it, press Next",
done_member_regist_description_2: "From now on, we will support AELU to obtain a specific skill visa by preparing a lot of certification exams.",
done_member_regist_2: "Member registration is complete.",
is_exist_user: "A user with the same email address already exists.",
invitation_code_description: "(Please enter the invitation code from the sending organization or Japanese language school, otherwise the expense settlement screen will appear, so don&#39;t forget to enter it.)",
pleace_select_region: "Please select the host prefecture",
pleace_add_messenger: "All contacts will be sent via Facebook messager so be sure to add them",
add_messenger_bot: "Receive notifications",
visa_application_description: "Required document storage location when applying for a specific skill visa",
check_agree: "Please agree",
sample_title: "This is a dummy title. Please set",
sample_description: "This is a dummy description. Please set. This is a dummy description. Please set. This is a dummy description. Please set. This is a dummy description. Please set. This is a dummy description. Please set. This is a dummy description. Please set. This is a dummy description. Please set.",
create_profile_error: "There is an error in the input. Please check the item",
setting_confirm: "Please confirm the input contents and register",
exam_learning: "Exam learning",
recommend_problem_solve: "Solve similar exam questions",
of: "of",
see_solved_problem: "Solve problems you have solved in the past \ n",
past_exam_collection: "\ N exam questions that appeared in the past",
any_application_registration: "Various application registration",
mypage_visa_application: "Specific skill visa \ n application",
applyt_exam_and_agent: "Exam application \ n Proxy service application",
myapge_regist_accept_certificate: "Skill test \ nRegistration of pass",
mypage_consultaion_service: "Learning consultation \ n service",
consultaion_service: "Learning consultation service",
consult: "Consult",
of_exam_day: "Test date",
your_ave_score: "Average score for your \ n test",
your_estimated_pass_rate: "Your \ n estimated pass rate",
your_ave_score_fotter: "Average score for your test",
your_estimated_pass_rate_fotter: "Estimated pass rate",
mypage_study_text: "Download learning textbook \ n",
exam_schedule: "Exam schedule",
resident_caption_title: "● About uploading a residence card or ID card",
resident_caption: "Please upload a residence card or ID card that can confirm the information in the red frame. \ nPlease upload a valid residence card or ID card that has not expired. \ nUpload a color image in PDF or JPG format.",
password_caption_title: "● About uploading passwords",
password_caption: "Please upload a passport image that confirms your name / photo / unique number / date of birth / nationality / expiration date as shown in the red frame. \ nPlease upload a valid passport that has not expired. \ nUpload a color image in PDF or JPG format.",
title_help: "help",
step3_title_help: "Please enter your information correctly.",
lineid_input_help: "Open LINE → Home → Settings → Profile → Scroll to see the ID. Please enter that ID. If you have not created it, please create it and enter it.",
country_input_help: "Please select the country of your nationality.",
area_input_help: "Select the country of your area where you currently live.",
phone_input_help: "Please enter your phone number.",
issuing_input_help: "Please select the area where your ID was issued.",
idtype_input_help: "Please select an ID type. Please take a beautiful picture of the selected person and upload it. Please shoot straight so that there are no diagonal or cut points.",
invitation_input_help: "If you have an invitation code, enter it.",
exam_menu_help: "There will be questions that are similar to the questions that were actually asked in the past. Solve repeated questions to prepare for the exam.",
past_menu_help: "You will have problems that you have solved in the past. Let&#39;s review the mistakes.",
pastexam_menu_help: "This is the text of the exam questions that were actually in the past.",
text_menu_help: "You can look at the study textbooks to study the important points and find out what you do not understand.",
visa_menu_help: "We will help you obtain a specific skill visa. If you would like to obtain a visa for a specific skill, please apply here.",
agency_menu_help: "We will apply for the specific proficiency test on your behalf. If you would like to take a specific skill test, please apply here.",
cer_menu_help: "If you have taken the specific proficiency test and have a pass certificate, please register here.",
service_menu_help: "If you have any questions or concerns, please contact us via chat here.",
occu_title_help: "Please select up to 3 desired occupations.",
back: "return",
before: "To the previous problem",
srilank: "Sri Lanka",
reselect: "If you want to change the file, press &quot;Upload your passport&quot; again and select again",
iphone_file: "For iphone, please use after converting from HEIC file to JPG file.",
file_transmit: "Convert files",
combodia: 'combodia',
}
